import { render, staticRenderFns } from "./AccountStoreForm.vue?vue&type=template&id=2a96005d"
import script from "./AccountStoreForm.vue?vue&type=script&lang=js"
export * from "./AccountStoreForm.vue?vue&type=script&lang=js"
import style0 from "./AccountStoreForm.vue?vue&type=style&index=0&id=2a96005d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports